// eslint-disable-next-line import/no-unresolved
import * as getStatic from '@backpackjs/core-nextjs/get-static';

import { CartPage as CartPageComp } from '../snippets';

export const getStaticProps = getStatic.props.settings;

export default function CartPage() {
  return <CartPageComp />;
}
